import React from 'react';
import LightState from './LightState'
import './LightStateRow.css';

class LightStateRow extends React.Component {

  constructor(props){
    super(props);
    this.circuitToggled = this.circuitToggled.bind(this)
  }

  circuitToggled(name, newValue) {
    if (typeof this.props.onChange === "function") this.props.onChange(name, newValue ? 'on' : 'off');
  }

  render() {
    const ls = (this.props.lightStates.map((ls, ix)=> {
      return (<LightState name={ls.name} 
                          lightState={ls.value} 
                          circuit={ls.circuit}
                          onChange={this.circuitToggled}
                          processing={ls.value} />)
    }));
    return (
      <div className="LightStateRow">
        
        {ls}
        
      </div>
    );
  }
}


export default LightStateRow;
